// extracted by mini-css-extract-plugin
export default {"root":"style_root__UzouS","banner":"style_banner__bVjWs","spalte":"style_spalte__v358v","menu":"style_menu__-vR8k","inhalt":"style_inhalt__G1XFp"};